import { render, staticRenderFns } from "./vFooter.vue?vue&type=template&id=2c92b5e0&scoped=true&"
import script from "./vFooter.vue?vue&type=script&lang=js&"
export * from "./vFooter.vue?vue&type=script&lang=js&"
import style0 from "./vFooter.vue?vue&type=style&index=0&id=2c92b5e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c92b5e0",
  null
  
)

/* custom blocks */
import block0 from "./vFooter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports